import { Icon } from '~/atomic/atoms/Icon/view';
import { Text } from '~/atomic/atoms/Text/view';
import { useAppSelector } from '~/store';
import {
  selectPlanSlug,
  selectSubscription,
} from '~/store/entitlements/selectors';

interface NoActivePlanBannerProps {
  onClickCta?: () => void;
  ctaText?: string;
}

export default function NoActivePlanBanner({
  onClickCta,
  ctaText = 'Conhecer planos',
}: NoActivePlanBannerProps) {
  const planSlug = useAppSelector(selectPlanSlug);
  const subscription = useAppSelector(selectSubscription);

  if (subscription) return null;
  if (planSlug !== 'free') return null;

  return (
    <article className="relative overflow-hidden rounded-medium border border-support-01 bg-intense-01 shadow-level1">
      <div className="flex h-[6px]">
        <div className="w-1/2 bg-primary-01" />
        <div className="w-1/4 bg-secondary-01" />
        <div className="w-1/4 bg-support-01" />
      </div>

      <div className="flex flex-col gap-medium p-medium md:flex-row md:items-center md:justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-quark">
            <span className="inline-flex items-center rounded-full bg-primary-01 px-nano py-quark text-[10px] font-bold uppercase tracking-[0.12em] color-intense-01">
              Plano Free
            </span>
            <span className="inline-flex items-center gap-quark text-caption color-intense-05">
              <Icon
                name="icon-graphic-up"
                size={12}
                color="#3F7D5F"
                rounded={false}
              />
              <span>desbloqueie tudo</span>
            </span>
          </div>

          <Text className="mt-smaller text-headingH2 color-complement-01">
            Tire o pé do freio da sua safra
          </Text>
          <Text className="mt-quark text-bodySM color-intense-06">
            Você está no plano gratuito. Libere extração de PDF ilimitada,
            previsão de pagamentos e alertas no app.
          </Text>

          <ul className="mt-smaller flex flex-col gap-quark text-bodySM color-intense-07">
            <li className="flex items-center gap-nano">
              <span className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-support-01">
                <Icon
                  name="icon-check"
                  size={11}
                  color="#1D4733"
                  rounded={false}
                />
              </span>
              Extração de PDF sem limite mensal
            </li>
            <li className="flex items-center gap-nano">
              <span className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-support-01">
                <Icon
                  name="icon-check"
                  size={11}
                  color="#1D4733"
                  rounded={false}
                />
              </span>
              Previsão dos próximos 14 dias e alertas no app
            </li>
            <li className="flex items-center gap-nano">
              <span className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-support-01">
                <Icon
                  name="icon-check"
                  size={11}
                  color="#1D4733"
                  rounded={false}
                />
              </span>
              Múltiplas fazendas e relatórios avançados
            </li>
          </ul>
        </div>

        <button
          type="button"
          onClick={onClickCta}
          className="inline-flex items-center justify-center gap-quark self-start rounded-nano border border-primary-01 px-medium py-smaller text-bodyMD font-medium color-primary-01 transition-colors hover:bg-support-01 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-01/30 md:self-auto"
        >
          {ctaText}
          <Icon name="icon-chevron-right" size={14} color="#1D4733" rounded={false} />
        </button>
      </div>
    </article>
  );
}
